import { gql } from '@src/lib/gql'

/**
 * W4: the viewer's memberships with their scheduled change. Separate from `useCurrentUser` so
 * the pending fields load only where Plans and billing need them; Apollo merges them into the
 * same normalized `ScoSubscription` rows.
 */
export const MEMBERSHIP_PLAN_CHANGE = gql`
  query MembershipPlanChange {
    viewer {
      id
      currentUser {
        id
        subscriptions {
          id
          subscriptionId
          productId
          isActive
          isLifetime
          state
          delayedCancelAt
          nextAssessmentAt
          currentPeriodEndsAt
          hasPendingChange
          pendingProductId
          pendingTermId
          pendingChangeAt
          pendingProduct {
            id
            productId
            name
          }
          product {
            id
            productId
            name
            termId
            effectiveTermId
          }
        }
      }
    }
  }
`

/**
 * The end-of-term quote for a move down (startups3 detects `down`: nothing due now, the renewal
 * price from Chargebee's next invoice estimate, only coupons valid for the target).
 */
export const SUBSCRIPTION_DOWNGRADE_QUOTE = gql`
  query SubscriptionDowngradeQuote($subscriptionId: String!, $productId: String!, $termId: String) {
    scoSubscriptionChangeQuote(subscriptionId: $subscriptionId, productId: $productId, termId: $termId) {
      id
      direction
      changeOption
      effectiveAt
      couponIds
      droppedCouponIds
      dueNowInCents
      nextBillingAt
      nextBillingAmountInCents
      product {
        id
        productId
        name
        termId
        effectiveTermId
        effectiveTerm {
          abbreviation
          name
        }
      }
    }
  }
`

/**
 * The founder's active Advisor Team seats (`sourceKey: team`), the same `advisorEngagements`
 * root My Advisors reads. They end at the change through startups3 `syncTeamEngagementsForUser`.
 */
export const ACTIVE_TEAM_SEATS = gql`
  query ActiveTeamSeats {
    advisorEngagements(role: "FOUNDER", statusKeys: ["active"], sourceKeys: ["team"], pageSize: 50) {
      items {
        id
        advisorEngagementId
        advisorUserId
        advisorName
        sourceKey
        statusKey
        advisorUser {
          id
          userId
          fullName
          displayName
        }
        category {
          id
          key
          title
        }
      }
    }
  }
`
